import React, { memo } from "react";
import useProfileDetail from "./index.hooks";
import { CreateMerchantBannerDialog, ProfilePreview } from "../index";

type ProfileDetailProps = {};

const ProfileDetail = ({}: ProfileDetailProps) => {
  const { styles, classes, atomicStyles, merchant } = useProfileDetail();

  return (
    <div className={styles.profileCard}>
      <ProfilePreview merchant={merchant} />
    </div>
  );
};

export default memo(ProfileDetail);
